<template>
  <div>
    <v-row
      v-if="isRedirect"
      class="py-1"
    >
      <v-col>
        <v-btn
          color="dark"
          text
          small
          @click="redirect()"
        >
          <v-icon> mdi-arrow-left </v-icon>
        </v-btn>
        <div class="pb-3 ml-3 redirect-back" />
      </v-col>
    </v-row>
    <v-card
      elevation="4"
      :loading="isLoading"
      class=""
    >
      <div class="Customer-Details">
        <div
          v-if="isLoading"
          class="d-flex"
        >
          <v-skeleton-loader
            v-for="i in 3"
            :key="i"
            type="list-item-two-line"
            style="flex: 1"
          />
        </div>
        <div
          v-else
          class="Customer-Details-Info"
          :class="isShow ? 'half-w' : 'full-w'"
        >
          <span class="info-box">
            <v-card-text>
              <table>
                <tr>
                  <td>Customer Name:</td>
                  <td>
                    <v-chip>
                      {{ items.customer_name }}
                    </v-chip>
                  </td>
                </tr>

                <tr>
                  <td>Battery Serial No:</td>
                  <td>
                    <v-chip>
                      {{ items.serial_no }}
                    </v-chip>
                  </td>
                </tr>
                <tr>
                  <td>IMEI:</td>
                  <td>
                    <div class="d-flex align-center">
                      <div>
                        <v-chip>
                          {{ getIMEI }}
                        </v-chip>
                      </div>
                      <div class="ml-3">
                        <copy-content :content="getIMEI" />
                      </div>
                    </div>
                  </td>
                </tr>
              </table>
            </v-card-text>
          </span>
          <span class="info-box">
            <v-card-text>
              <table>
                <tr>
                  <td>Make & Model:</td>
                  <td>
                    <v-chip>
                      {{ items.battery_make_model }}
                    </v-chip>
                  </td>
                </tr>
                <tr>
                  <td>Battery Chemistry:</td>
                  <td>
                    <v-chip>
                      {{ items.battery_type_name }}
                    </v-chip>
                  </td>
                </tr>
                <tr v-if="items.vehicle_battery_type != 'swappable'">
                  <td>No of Cell:</td>
                  <td>
                    <v-chip>
                      {{ items.no_of_cell }}
                    </v-chip>
                  </td>
                </tr>
              </table>
            </v-card-text>
          </span>
          <span class="info-box">
            <v-card-text>
              <table>
                <tr>
                  <td>Capacity :</td>
                  <td>
                    <v-chip>
                      {{ items.capacity }}
                    </v-chip>
                  </td>
                </tr>
                <!-- <tr>
                  <td>Last Charge At:</td>
                  <td>{{ items.last_charge_at }}</td>
                </tr> -->
                <tr>
                  <td>Remaining Capacity:</td>
                  <td>
                    <v-chip>
                      {{ items.remaining_capacity }}
                    </v-chip>
                  </td>
                </tr>
                <!-- <tr>
                  <td>State of Health:</td>
                  <td>{{ items.soh }}</td>
                </tr> -->
                <!-- <tr>
                  <td>Time of Charge:</td>
                  <td>{{ items.time_of_charge }}</td>
                </tr> -->
              </table>
            </v-card-text>
          </span>
        </div>
        <div
          v-if="!isLoading"
          class="Toggle-btn"
        >
          <v-btn
            color="primary"
            fab
            small
            @click="isShow = !isShow"
          >
            <v-icon v-if="isShow">
              mdi-chevron-up
            </v-icon>
            <v-icon v-else>
              mdi-chevron-down
            </v-icon>
          </v-btn>
        </div>
      </div>

      <!-- v-if="$admin.can('users.edit')" -->
      <edit-user
        v-if="editUserModal"
        :is-visible-dialog="editUserModal"
        :read-only="true"
        :toggle-edit="toggleUserModal"
        :oem-customer="selectedUser"
      />
      <!-- v-if="$admin.can('iot-devices.edit')" -->
      <EditDevice
        v-if="editDeviceModal"
        :is-visible-dialog="editDeviceModal"
        :read-only="true"
        :toggle-edit="toggleIOTModal"
        :iot-device="selectedUser"
      />
      <!-- v-if="$admin.can('vehicles.edit')" -->
      <edit-vehicle
        :is-visible-dialog="editVehicleModal"
        :read-only="true"
        :toggle-edit="toggleVehicleModal"
        :vehicle="selectedUser"
      />
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  components: {
    EditUser: () =>
      import("@/views/modules/customer/dialogs/EditOemCustomer.vue"),
    EditDevice: () =>
      import("@/views/modules/iot-devices/dialogs/EditIotDevice.vue"),
    EditVehicle: () =>
      import("@/views/modules/vehicles/dialogs/EditVehicleTabs.vue"),
    CopyContent: () => import("@/components/base/CopyContent.vue"),
  },
  props: {
    isRedirect: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  data() {
    return {
      isShow: false,
      selectedUser: {},
      editUserModal: false,
      editDeviceModal: false,
      editVehicleModal: false,
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "batterries/isLoadingBatterries",
      items: "batterries/batterriesItem",
    }),
    getIMEI() {
      return this.$route.params.imei;
    },
  },
  async beforeDestroy() {
    await this.$store.commit("batterries/SET_BATTERIES_ITEM", []);
  },
  async beforeMount() {
    const params = {
      id: this.$route.query.battery_id,
    };
    if (this.$route.query.bmsId) {
      params.bmsId = this.$route.query.bmsId;
    }
    await this.$store.dispatch("batterries/show", params);
  },
  methods: {
    showUserModal(item) {
      this.selectedUser = { ...item.customer };
      this.toggleUserModal();
    },
    toggleUserModal() {
      return (this.editUserModal = !this.editUserModal);
    },
    showIOTModal(item) {
      this.selectedUser = { ...item.iotDevice };
      this.toggleIOTModal();
    },
    toggleIOTModal() {
      return (this.editDeviceModal = !this.editDeviceModal);
    },
    showVehicleModal(item) {
      this.selectedUser = { ...item };
      this.toggleVehicleModal();
    },
    toggleVehicleModal() {
      return (this.editVehicleModal = !this.editVehicleModal);
    },
    redirect() {
      this.$emit("redirect");
    },
  },
};
</script>
<style lang="sass" scoped>
.Customer-Details
  position:  relative
  .Toggle-btn
    position: absolute
    width: 100%
    display: flex
    justify-content: center
    bottom: -1.5rem
    z-index: 9
.Customer-Details-Info
  display: flex
  justify-content: space-between
  gap: 1rem
  padding: 1rem 2rem
  flex-wrap: wrap
  -webkit-flex-wrap: wrap
  // max-height: 100px
  // overflow: hidden
  // transition: all 1s linear
  .info-box
    width: 300px
    max-height: 45px
    overflow: hidden
    transition: all 1s linear
    margin: 0.5rem 0
    text-wrap: nowrap
    .v-card__text
      padding: 0
      table
        width:100%
        font-size: 12px
      tr td:first-child
        color: gray
      tr td:last-child
        font-weight: 600
  li
    list-style: none
    padding: 5px
    width: 160px
    label
      font-size: 12px
      color: gray
    p
      font-weight: bold

.half-w
  .info-box
    max-height: 50vh
</style>
